/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { DialogDefaultV2, TrueFalseSelectV2 } from '../../../components/v2';

const ValidarDialog = ({ open, onClose, onConfirm, showDespesaFatura }) => {
  const [despesaFatura, setDespesaFatura] = useState('');

  useEffect(() => {
    if (open) setDespesaFatura('');
  }, [open]);

  const handleConfirm = () => {
    onConfirm({ despesaFatura: showDespesaFatura ? despesaFatura : undefined });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Validar nota"
      confirmMessage="Validar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: showDespesaFatura ? 2 : 0 }}>
        Confirme a validação desta nota.
        {showDespesaFatura && ' Informe se a despesa consta na fatura do cartão corporativo.'}
      </Typography>
      {showDespesaFatura && (
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12 }}>
            <TrueFalseSelectV2
              label="Despesa na Fatura"
              name="despesaFatura"
              onChange={(event) => setDespesaFatura(event.target.value)}
              value={despesaFatura}
            />
          </Grid>
        </Grid>
      )}
    </DialogDefaultV2>
  );
};

ValidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  showDespesaFatura: PropTypes.bool,
};

ValidarDialog.defaultProps = {
  showDespesaFatura: false,
};

export default ValidarDialog;
